(function ($) {

    $(document)

    // minimize/maxymize desctop menu
        .on('click', '#minimizeSidebar', function (e) {
            var b = $('body').toggleClass('app-nav-small');
            $.cookie('app-nav-small', (b.hasClass('app-nav-small')) ? 1 : 0, {expires: 7, path: '/'});
        })

        // open/close mobile menu
        .on('click', '#dashboard-top-nav .navbar-toggle', function () {
            $("#app-nav, #app-content").toggleClass("isOpenMobileNav");
        })
        .ready(function () {

            setTimeout(function () {
                $('#app-nav').addClass('on-animate');
            }, 800);

            $('#app-nav div.collapse li.active').each(function () {
               $(this).parents('div.collapse').addClass('in');
            });


        })
    ;

    if ($.cookie('app-nav-small') == 1) {
        $('body').addClass('app-nav-small');
    }


})(jQuery);